module.exports = __webpack_public_path__ + "img/icon-home.526d582.webp";